<template>
  <MainLayout>
    <v-layout style="padding: 1em" justify-center row fill-height>
      <v-flex>
        <v-card style="height: 100%" light color="#f4f4fa">
          <v-layout column style="height: 100%">
            <!-- Title -->
            <v-card-title row class="align-center">
              <span class="headline flex-none">Service Requests</span>
            </v-card-title>

            <!-- Filter -->
            <div class="d-flex flex-xs-column justify-end align-center">
              <!-- Search Field -->
              <v-text-field
                class="mx-4 flex"
                v-model="filters.search"
                label="Search by id, user, vendor, service"
                clearable
                prepend-icon="search"
                @input="getOrders"
              />

              <!-- Status Selection -->
              <v-select
                v-model="filters.status"
                class="mx-4"
                :items="['Pending', 'Accepted', 'Rejected']"
                label="Status"
                clearable
                prepend-icon="playlist_add_check"
                style="width: 5em"
                @change="getOrders"
              />

              <!-- Filter Date Range -->
              <div class="flex-none d-flex mx-4">
                <DatePicker
                  v-model="filters.fromDate"
                  clearable
                  label="From Date"
                  @change="getOrders"
                />

                <DatePicker
                  v-model="filters.toDate"
                  clearable
                  label="To Date"
                  @change="getOrders"
                />
              </div>
            </div>

            <!-- Table -->
            <v-container fluid fill-height class="full-height">
              <v-layout style="padding: 0" class="full-height">
                <v-flex sm12 md12 class="full-height scroll">
                  <v-data-table
                    :headers="headers"
                    :items="orders"
                    :pagination.sync="pagination"
                    :rows-per-page-items="[10, 50, 100]"
                    :total-items="pagination.totalItems"
                    :loading="loading"
                    @update:pagination="getOrders"
                    class="elevation-1"
                  >
                    <!-- When items = [] -->
                    <template v-slot:no-data>
                      <div style="text-align: center">
                        {{
                          loading
                            ? "Please wait a moment "
                            : "No matching records found"
                        }}
                      </div>
                    </template>

                    <!-- When items = undefined -->
                    <template v-slot:no-results>
                      <div style="text-align: center">
                        {{
                          loading
                            ? "Please wait a moment "
                            : "Data will be displayed in here"
                        }}
                      </div>
                    </template>

                    <template v-slot:items="props">
                      <!-- Generated -->
                      <td>{{ props.item.created_at | date }}</td>

                      <!-- Job ID -->
                      <td>{{ props.item.id }}</td>

                      <!-- Customer Name -->
                      <td>{{ props.item.user && props.item.user.name }}</td>

                      <!-- Service Category -->
                      <td>
                        {{
                          props.item.vendor &&
                            props.item.vendor.service &&
                            props.item.vendor.service.name
                        }}
                      </td>

                      <!-- Vendor Name -->
                      <td style="display: flex; align-items: center;">
                        <v-menu
                          v-if="props.item.vendor"
                          open-on-hover
                          bottom
                          offset-y
                        >
                          <template v-slot:activator="{ on }">
                            <v-btn
                              small
                              icon
                              style="margin-right: 0.3125em;"
                              v-on="on"
                            >
                              <v-icon small>local_phone</v-icon>
                            </v-btn>
                          </template>

                          <v-card>
                            <v-card-title>
                              +91-{{
                                props.item.vendor &&
                                  props.item.vendor.user.mobile
                              }}
                            </v-card-title>
                          </v-card>
                        </v-menu>

                        <span>{{
                          props.item.vendor && props.item.vendor.user.name
                        }}</span>
                      </td>

                      <!-- Status -->
                      <td>
                        <span v-if="typeof props.item.accepted !== 'boolean'">
                          Pending
                        </span>
                        <template v-else>
                          <span
                            v-if="props.item.accepted"
                            style="color: var(--success)"
                          >
                            Accepted
                          </span>
                          <span v-else style="color: var(--danger)">
                            Rejected
                          </span>
                        </template>
                      </td>

                      <!-- Service Details -->
                      <td>
                        <v-btn
                          title="View Details"
                          icon
                          @click="viewOrderDetails(props.item)"
                        >
                          <v-icon small>visibility</v-icon>
                        </v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Order Details -->
    <v-dialog v-if="currentOrder" width="37.5em" v-model="orderDetailsDialog">
      <v-flex light sm12 md12 class="full-height scroll">
        <!-- Header -->
        <v-toolbar color="primary" dark>
          <v-toolbar-title>
            Request Details
          </v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="orderDetailsDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <!-- Content -->
        <v-card light>
          <v-container fluid grid-list-lg>
            <v-layout column>
              <table class="order-details-table">
                <tbody>
                  <tr>
                    <td>Job ID:</td>
                    <td>{{ currentOrder.id }}</td>
                  </tr>

                  <tr>
                    <td>Service Description:</td>
                    <td>{{ currentOrder.description }}</td>
                  </tr>

                  <tr>
                    <td>Scheduled Date:</td>
                    <td>{{ currentOrder.date }}</td>
                  </tr>

                  <tr>
                    <td>Scheduled time:</td>
                    <td>
                      {{ currentOrder.time_of_day_start | timeOfDay }} -
                      {{ currentOrder.time_of_day_end | timeOfDay }}
                    </td>
                  </tr>

                  <tr>
                    <td>Address:</td>
                    <td>{{ currentOrder.address }}</td>
                  </tr>

                  <tr>
                    <td>Status:</td>
                    <td>
                      <span v-if="typeof currentOrder.accepted !== 'boolean'">
                        Pending
                      </span>
                      <template v-else>
                        <span
                          v-if="currentOrder.accepted"
                          style="color: var(--success)"
                        >
                          Accepted
                        </span>
                        <span v-else style="color: var(--danger)">
                          Rejected
                        </span>
                      </template>
                    </td>
                  </tr>

                  <tr
                    v-if="
                      typeof currentOrder.accepted === 'boolean' &&
                        !currentOrder.accepted
                    "
                  >
                    <td>Reason for Cancel:</td>
                    <td>
                      {{ currentOrder.remarks }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-dialog>
  </MainLayout>
</template>

<script>
import moment from "moment";
import DatePicker from "@/components/DatePicker";
import sdk from "@/api/sdk";
import { debounce } from "@/utils/Debounce";

export default {
  metaInfo: {
    title: "Service Requests",
    meta: [
      {
        name: "Service Requests",
        content: "service requests, orders management"
      }
    ]
  },

  components: {
    DatePicker
  },

  data() {
    return {
      currentOrder: null,
      orderDetailsDialog: false,

      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: null,
        totalItems: 0
      },

      filters: {
        search: undefined,
        status: undefined,
        fromDate: undefined,
        toDate: undefined
      },

      loading: false,
      orders: undefined,

      headers: [
        {
          text: "Generated",
          width: 100,
          sortable: true,
          value: "created_at"
        },
        {
          text: "Job ID",
          width: 50,
          sortable: true,
          value: "id"
        },
        {
          text: "Customer Name",
          sortable: false
        },
        {
          text: "Service Category",
          sortable: false
        },
        {
          text: "Vendor Name",
          sortable: false
        },
        {
          text: "Status",
          value: "accepted",
          sortable: false
        },
        {
          text: "Service Details",
          width: 50,
          sortable: false
        }
      ]
    };
  },

  mounted() {
    this.getOrders();
  },

  methods: {
    getOrders: debounce(async function() {
      try {
        this.loading = true;
        this.orders = undefined;

        const res = await sdk.request({
          url: "/orders",
          params: {
            sort_by: this.pagination.sortBy,
            sort_direction: this.pagination.descending ? "desc" : "asc",
            page_size: this.pagination.rowsPerPage,
            page: this.pagination.page,
            search: this.filters.search || undefined,
            status: this.filters.status || undefined,
            start_time: this.filters.fromDate
              ? moment(this.filters.fromDate)
                  .startOf("day")
                  .format()
              : undefined,
            end_time: this.filters.toDate
              ? moment(this.filters.toDate)
                  .endOf("day")
                  .format()
              : undefined
          }
        });

        this.loading = false;
        this.orders = res.data.data;
        this.pagination.totalItems = res.data.total;
      } finally {
        this.loading = false;
      }
    }, 500),

    viewOrderDetails(order) {
      this.currentOrder = order;
      this.orderDetailsDialog = true;
    }
  }
};
</script>

<style lang="css" scoped>
.full-height {
  flex: 1 1 auto;
  min-height: 0;
}

.scroll {
  overflow-y: auto;
}

.title-text {
  flex: 1;
}

.search-field {
  flex: none;
  width: 25em;
}

.filter-select {
  flex: none;
  margin-left: 0.625em;
  width: 15em;
}

.order-details-table {
  border-spacing: 0 0.3125em;
}

.order-details-table > tbody > tr > td:first-child {
  white-space: nowrap;
  text-align: right;
  color: var(--secondary-text);
  vertical-align: text-top;
  font-weight: 600;
  width: 200px;
}

.order-details-table > tbody > tr > td:last-child {
  padding-left: 1.875em;
}

.order-details-table > tbody > tr {
  margin: 0.625em 0;
}
</style>
